import toast from 'react-hot-toast';
import { useId, useState, useEffect } from 'react';

import {
	useAxios,
	Container,
	ContentWrapper,
	ContentSection,
	ContentSectionDivider,
} from '@pangea-lis-apps/ui';
import {
	Pagination,
	NonClinicData,
	initialPaginationValues,
} from '@pangea-lis-apps/utils';

import ViewSamplesTable, {
	ViewSamplesProjectedFields,
} from '../../components/view-samples-table';
import TableSearchFiltersForm from '../../components/table-search-filters-form';

/* eslint-disable-next-line */
export interface ViewNewReportsProps {}

export default function ViewNewReports(props: ViewNewReportsProps) {
	const toastId = useId();
	const axios = useAxios(toastId);

	const [query, setQuery] = useState({});
	const [disabled, setDisabled] = useState(false);
	const [data, setData] = useState<NonClinicData[] | undefined>(undefined);
	const [pagination, setPagination] = useState<Pagination>(
		initialPaginationValues
	);

	useEffect(() => {
		let unmounted = false;

		const fetchData = async () => {
			if (!axios) return;

			try {
				if (!unmounted) {
					setData(undefined);
					setDisabled(false);
				}

				toast.loading('Loading...');

				const {
					data: {
						data: { data, total_entries },
					},
				} = await (
					await axios
				).post(
					`/api/organization-shared/search/reports?page_number=${pagination.page_number}&entries_per_page=${pagination.entries_per_page}`,
					{
						query: {
							...query,
							'sample.status': ['verified', 'reject'],
							'sample.report.downloaded.value': false,
						},
						projected_fields: ViewSamplesProjectedFields,
					}
				);

				if (!unmounted) {
					const parseData = JSON.parse(data);
					// console.log(parseData, total_entries);

					setData(parseData);
					setPagination((prev) => ({
						...prev,
						total_entries: total_entries,
					}));
				}
			} catch (error) {
				console.log(error);
			}

			if (!unmounted) setDisabled(false);
			toast.dismiss();
		};

		fetchData();

		return () => {
			unmounted = true;
			toast.dismiss();
		};
	}, [query, axios, pagination.page_number, pagination.entries_per_page]);

	return (
		<Container>
			<ContentWrapper
				heading="New Reports"
				Icon="DocumentChartBarIcon"
				description="New test reports to be viewed by your facility."
			>
				<TableSearchFiltersForm
					tableType="report"
					disabled={disabled}
					setQuery={setQuery}
					setPagination={setPagination}
				/>

				<ContentSectionDivider />

				<ContentSection heading="New reports">
					<ViewSamplesTable
						data={data}
						tableType="report"
						query={{ query, setQuery }}
						pagination={{ pagination, setPagination }}
					/>
				</ContentSection>
			</ContentWrapper>
		</Container>
	);
}
